<template>
  <div class="mb-10" v-if="item">
    <b-card
      class="mb-3 rounded-card spark-variant-primary-bg-light spark-variant-primary-border spark-variant-text-dark spark-block-content"
      header-class="card-header rounded-card-header fw-400 py-4 px-4 green-bottom-border spark-variant-primary-bg"
    >
      <template #header>
        <b-row>
          <b-col>
            <div class="spark-block-title">
              <i
                class="fas fa-hourglass-start icon-extra-large spark-variant-secondary-text mr-2"
              ></i>
              {{ $options.short_name }}
            </div>
          </b-col>
        </b-row>
      </template>

      <b-row class="mb-5">
        <b-col class="col-6 font-weight-bold text-right">Action required</b-col>
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <i
            v-if="item.action_required !== false"
            class="fas fa-check-circle red icon-large"
          ></i>
          <i v-else class="fas fa-times-circle green icon-large"></i>
          {{ item.action_required !== false ? "Yes" : "No" }}
          <div>
            <b-button
              v-if="item.action_required !== false"
              size="md"
              class="mt-5 rounded spark-variant-secondary-bg spark-variant-secondary-border spark-variant-text-light font-weight-bold"
              @click="$spark.$fix('claim')"
              >Fix Problems</b-button
            >
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="col-6 font-weight-bold text-right"
          >Number of active claims</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ item.total }}</span>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="col-6 font-weight-bold text-right"
          >Number of claims needing action</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ item.actions.length }}</span>
        </b-col>
      </b-row>
      <b-row class="mb-5" v-if="awaitingInfo.length > 0">
        <b-col class="col-6 font-weight-bold text-right"
          >Numbere of claims awaiting information</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ awaitingInfo.length }}</span>
        </b-col>
      </b-row>
      <b-row class="mb-5" v-if="awaitingDocs.length > 0">
        <b-col class="col-6 font-weight-bold text-right"
          >Number of claims awaiting documents</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ awaitingDocs.length }}</span>
        </b-col>
      </b-row>
      <b-row class="mb-5" v-if="awaitingCustomerApproval.length > 0">
        <b-col class="col-6 font-weight-bold text-right"
          >Number of claims awaiting customer approval</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ awaitingCustomerApproval.length }}</span>
        </b-col>
      </b-row>
      <b-row class="mb-5" v-if="awaitingFurtherInfo.length > 0">
        <b-col class="col-6 font-weight-bold text-right"
          >Number of claims awaiting further information</b-col
        >
        <b-col class="col-6">
          <i class="fas fa-paw"></i>
          <span class="fa-stack">
            <i
              class="fas fa-circle fa-stack-1x icon-large spark-variant-primary-text"
            ></i>
            <i
              class="fas fa-hashtag fa-stack-1x ml-3 spark-variant-text-light"
              style="font-size: 0.8em;"
            ></i>
          </span>
          <span class="ml-13">{{ awaitingFurtherInfo.length }}</span>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  CURRENT_USER,
  PROBLEM_AWAITING_VET_INFO,
  PROBLEM_AWAITING_VET_DOCS,
  PROBLEM_AWAITING_CUSTOMER_INFO,
  PROBLEM_AWAITING_CUSTOMER_DOCS,
  PROBLEM_AWAITING_CUSTOMER_APPROVAL,
  PROBLEM_AWAITING_CUSTOMER_FURTHER_INFO
} from "@/core/services/vars.service";

export default {
  name: "Portal-Claim-Active",
  short_name: "Active Claims",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  created() {
    this.CURRENT_USER = CURRENT_USER;
  },
  computed: {
    awaitingInfo() {
      if (!this.item) return null;
      let prop = null;
      if (this.$store.getters[CURRENT_USER].$customer) {
        prop = PROBLEM_AWAITING_CUSTOMER_INFO;
      }
      if (this.$store.getters[CURRENT_USER].$vet) {
        prop = PROBLEM_AWAITING_VET_INFO;
      }
      return this.item.actions.filter(a => {
        if (a.action.hasOwnProperty(prop)) return true;
        return false;
      });
    },
    awaitingDocs() {
      if (!this.item) return null;
      let prop = null;
      if (this.$store.getters[CURRENT_USER].$customer) {
        prop = PROBLEM_AWAITING_CUSTOMER_DOCS;
      }
      if (this.$store.getters[CURRENT_USER].$vet) {
        prop = PROBLEM_AWAITING_VET_DOCS;
      }
      return this.item.actions.filter(a => {
        if (a.action.hasOwnProperty(prop)) return true;
        return false;
      });
    },
    awaitingCustomerApproval() {
      if (!this.item) return null;
      return this.item.actions.filter(a => {
        if (a.action.hasOwnProperty(PROBLEM_AWAITING_CUSTOMER_APPROVAL))
          return true;
        return false;
      });
    },
    awaitingFurtherInfo() {
      if (!this.item) return null;
      return this.item.actions.filter(a => {
        if (a.action.hasOwnProperty(PROBLEM_AWAITING_CUSTOMER_FURTHER_INFO))
          return true;
        return false;
      });
    }
  }
};
</script>
